import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Col } from "reactstrap";

class PricingBox extends Component {
    render() {
        return (
            <React.Fragment>
                {
                    this.props.pricings.map((pricing, key) =>
                        <Col lg="4" key={key} className="mt-3">
                            <div className="pricing-box bg-white text-center p-4">
                                <div className="plan-title mt-3 mb-4">
                                    <h5 className="mb-0">{pricing.title}</h5>
                                </div>
                                <div className="plan-price">
                                    <h6>${pricing.price}<span>/{pricing.duration}</span></h6>
                                </div>
                                <div className="plan-features mt-4 mb-4">
                                    <p>Online Scheduling & Calendar</p>
                                    <p>Secure and Free Text & Email Reminders</p>
                                    <p>SFBT Lockable Progress Notes Template</p>
                                    <p>SFBT Intake Form</p>
                                    <p>Upload and Store Documentation</p>
                                    <p>Unlimited Client and File Storage</p>
                                    <p>HIPAA Compliant</p>
                                    <p className="mb-0">Exceptional Customer Support</p>


                                </div>
                                <div className="mb-4">
                                <a href="https://app.solutionfocusednotes.com/auth/register" target="_blank" className="btn btn-custom">Join Now</a>

                                </div>
                            </div>
                        </Col>
                    )
                }
            </React.Fragment>
        );
    }
}

export default PricingBox;
